import { render } from "./statusArchiveProjects.vue?vue&type=template&id=bf6e5c90"
import script from "./statusArchiveProjects.vue?vue&type=script&lang=js"
export * from "./statusArchiveProjects.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__